const focus = (Id: string): void => {
    document.getElementById(Id)?.focus();    
};

const click = (Id: string): void => {
    document.getElementById(Id)?.click();
};

const Elements = {
    focus,
    click
};

export default Elements;